<div class="bg_a32" style="margin-top: 80px;" *ngIf="showFooter">
    <div class="footer">

        <div class="d_flex justify_space_bt footer_nav_and_newsletter">
            <div class="footer_b_links">
                <img src="../../../assets/images/Logo_white_new.png" width="198px" alt="footer_logo"
                    class="footer_logo">
                <ul class="footer_nav">
                    <li class="footer_links"><a href="https://homerise.com/" class="footer_nav_links">Sell</a></li>
                    <li class="footer_links dividr">|</li>
                    <li class="footer_links"><a href="https://homerise.com/buy" class="footer_nav_links">Buy</a></li>
                    <li class="footer_links dividr">|</li>

                    <li class="footer_links"><a href="https://homerise.com/about-us" class="footer_nav_links">About
                            Us</a>
                    </li>
                    <li class="footer_links dividr">|</li>

                    <li class="footer_links"><a href="https://homerise.com/contact-us" class="footer_nav_links">Contact
                            Us</a></li>
                </ul>
            </div>
            <div class="subscription_box">
                <h6 class="news-letter-heading">Subscribe to our newsletter</h6>
                <p>Keep up with real estate news, deals, and updates.</p>
                <form class="example-form">
                    <div class="d_flex email_box" style="gap: 8px;align-items: center;">
                        <input class="email_text_Field" type="text" placeholder="Email">
                        <button class="signUp_btn">Sign Up</button>
                    </div>
                </form>
            </div>
        </div>
        <div class="privacy">
            <p class="liscene">Real Estate Brokerage Licensure: REO200200265 (DC), CQ1060583 (FL), 0226029260 (VA),
                5000924 (MD),
                1649096 (NJ), RB068203 (PA)</p>
            <div class="copy">
                <p class="copy_right">© HomeRise.com LLC. All Rights Reserved.</p>
                <a href="https://homerise.com/privacy-policy/">Privacy Policy</a>
                <span class="bar">|</span>
                <a href="https://homerise.com/terms-and-conditions/"> Terms And Conditions</a>
            </div>
        </div>
    </div>
</div>